import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import axios from "axios";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import CircularProgress from '@mui/material/CircularProgress';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { API_ENDPOINTS } from "config/api";
import { decryptText } from "config/encryption";

// Fix leaflet's default icon path issues with webpack
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

// Helper to geocode district names (using OpenStreetMap Nominatim)
const geocodeDistrict = async (district) => {
  const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(district + ", India")}`;
  const res = await axios.get(url);
  if (res.data && res.data.length > 0) {
    return {
      lat: parseFloat(res.data[0].lat),
      lon: parseFloat(res.data[0].lon),
    };
  }
  return null;
};

const DistrictMap = () => {
  const [districts, setDistricts] = useState([]);
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedDistrict, setSelectedDistrict] = useState("All");

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const userDetails = localStorage.getItem("UserLogDetails");
        if (!userDetails) throw new Error("No user details");

        const decryptedUser = decryptText(userDetails);
        const parsedUser = JSON.parse(decryptedUser);
        const { Token } = parsedUser;

        if (!Token) throw new Error("Missing token");

        // Pass the token in the Authorization header
        const res = await axios.get(
          API_ENDPOINTS.PROFILE.GET_DISTRICT_SUMMARY,
          {
            headers: {
              Authorization: `Bearer ${Token}`,
            },
          }
        );
        setDistricts(res.data);

        // Geocode all districts
        const locs = await Promise.all(
          res.data.map(async (item) => {
            const coords = await geocodeDistrict(item.district);
            return coords ? { ...item, ...coords } : null;
          })
        );
        setLocations(locs.filter(Boolean));
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div style={{textAlign: "center", marginTop: "2rem"}}>
        <CircularProgress size={48} />
        <div style={{marginTop: 16}}>Loading Friends details...</div>
      </div>
    );  
  }

  return (
    <div>
      <div style={{ position: "sticky", top: 0, zIndex: 1000, background: "#fff", padding: "16px 0" }}>
        <Autocomplete
          options={["All", ...districts.map(d => d.district)]}
          value={selectedDistrict}
          onChange={(e, newVal) => setSelectedDistrict(newVal || "All")}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Filter by District"
              variant="outlined"
              style={{ width: 300 }}
            />
          )}
        />
      </div>
      <MapContainer center={[20.5937, 78.9629]} zoom={5} style={{ height: "600px", width: "100%" }}>
        <TileLayer
          attribution='&copy; OpenStreetMap contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {locations
          .filter(loc => selectedDistrict === "All" || loc.district === selectedDistrict)
          .map((loc, idx) => (
            <Marker key={idx} position={[loc.lat, loc.lon]}>
              <Popup>
                <b>{loc.district}</b><br />
                Alumni: {loc.studentCount}<br />
                Names: {loc.studentNames}
              </Popup>
            </Marker>
          ))}
      </MapContainer>
    </div>
  );
};

export default DistrictMap;
